import React from 'react'
import withSizes from 'react-sizes'
import animated_spoiler from '../../../../../custom_js/animated_spoiler'
import uuid from 'uuid'

const mapSizesToProps = ({ width }) => ({
  winW: width
})

let jsClassUnrollTextByTitle = 'a-' + uuid()

class SaleSertificate extends React.Component {
  bannerImgSrc() {
    return this.props.winW >= 1024
      ? '/img/2021/04/cert_dt2.jpg'
      : '/img/2021/04/cert_mob2.jpg'
  }

  promoLink = () =>
    'https://gate.zhovten-kino.kyiv.ua/seats.html?id=I000005165&specoof=Subs&src=BF&CinemaId=0000000026'

  render() {
    return (
      <div className='mp__sertificat bgc-lightyellow'>
        <div className='wd'>
          <div className='sertificat'>
            <div className='wrap__sale__link'>
              <a href={this.promoLink()}>
                <div className='wrap__seritficat__img'>
                  <img
                    className='seritficat__img'
                    src={this.bannerImgSrc()}
                    alt='Банер сертифікат'
                  />
                </div>
              </a>
            </div>

            <div
              className={`sertificat__title ${jsClassUnrollTextByTitle}`}
              onClick={() =>
                animated_spoiler({
                  tagSelector: '.' + jsClassUnrollTextByTitle,
                  contentSelector: '.sertificat__text'
                })
              }
            >
              Правила використання «Сертифікату на кіно» в кінотеатрі «Жовтень».
            </div>

            <div className='sertificat__text'>
              <div>
                <p className='sertificat__text__paragraph'>
                  1. Під поняттям «Сертифікат» розуміти – паперовий носій (затвердженого зразка) в
                  якому вручну вписаний унікальний електронний промокод, який був надрукований в
                  чеку або електронний сертифікат з промокодом отриманий на електронну пошту, яку ви
                  вказували при купівлі Сертифікату онлайн.
                </p>
                <p className='sertificat__text__paragraph'>
                  2. Сертифікат надає можливість пред’явнику обміняти його на один квиток у
                  кінотеатрі «Жовтень». Різниця між вартістю квитка та сертифікату не повертається
                  пред’явнику. Не підлягає поверненню чи обміну його на гроші.
                </p>
                <p className='sertificat__text__paragraph'>
                  3. Купуючи сертифікат (промокод) ви підтверджуєте, що ознайомлені з правилами його
                  використання. Фактом покупки ви затверджуєте, що після передачі подарункового
                  сертифікату (промокоду) третім особам пред’явник сертифікату буде ознайомлений з
                  умовами його використання.
                </p>
                <p className='sertificat__text__paragraph'>
                  4. Сертифікат можна придбати в касі і на сайті кінотеатру «Жовтень».
                </p>
                <p className='sertificat__text__paragraph'>
                  5. Діє на всі фільми, продаж на які здійснюється на сайті і в касі кінотеатру,
                  окрім закритих прем’єр та альтернативних показів (театральних постановок, балету,
                  тощо).
                </p>
                <p className='sertificat__text__paragraph'>
                  6. Щоб обміняти промокод сертифікату на квиток на сайті оберіть фільм, дату та час
                  сеансу, виберіть місце та введіть промокод у відповідне поле – квиток буде
                  надіслано вам на пошту, у касі – обмінюєте паперовий чи електронний промокод на
                  квиток.
                </p>
                <p className='sertificat__text__paragraph'>
                  7. Ви можете власноруч вписати унікальний промокод в паперовий носій
                  (затвердженого зразка), тобто Сертифікат. Отримати подарунковий паперовий
                  Сертифікат можете у адміністратора кінотеатру за наявності чека і листа з
                  отриманим промокодом.
                </p>
                <p className='sertificat__text__paragraph'>
                  8. Сертифікат дійсний 60 днів з моменту придбання в касі чи онлайн.
                </p>
                <p className='sertificat__text__paragraph'>
                  9. В разі виникнення непередбачуваних обставин через які ви не можете використати
                  сертифікат і активувати промокод в 60-денний термін, строк дії може бути
                  продовжений в індивідуальному порядку за попереднім дзвінком адміністратору.
                </p>
                <p className='sertificat__text__paragraph subtitle-change-rule'>
                  Більше інформації за телефоном: <a href='tel:+380672475973'>+380 67 247 59 73</a>
                </p>

                <p className='sertificat__text__paragraph'>Яскравих вражень!</p>
                <p className='sertificat__text__paragraph'>
                  Чекаємо вас за адресою: вул. Костянтинівська, 26, м. Київ.
                </p>
                <a className='mp__sec__content__button' href={this.promoLink()}>
                  Придбати сертифікат
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withSizes(mapSizesToProps)(SaleSertificate)



// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/saleCertificate.jsx